import service from "@/services/branchService";

export default {
  namespaced: true,
  state: {
    status: "",
    branchesList: null,
    branchSchedule: null,
  },

  getters: {
    status: (state) => {
      return state.status;
    },
    branchesList: (state) => {
      return state.branchesList;
    },
    branchSchedule: (state) => {
      return state.branchSchedule;
    },
  },

  mutations: {
    // Status
    STATUS_LOADING: (state) => {
      state.status = "loading";
    },
    STATUS_SUCCESS: (state) => {
      state.status = "success";
    },
    STATUS_ERROR: (state) => {
      state.status = "error";
    },
    ["SET_BRANCHES_LIST"]: (state, list) => {
      state.branchesList = list;
    },
    ["SET_BRANCH_SCHEDULE"]: (state, schedule) => {
      state.branchSchedule = schedule;
    },
  },

  actions: {
    getAvailableBranches({ commit }, params) {
      return new Promise((resolve, reject) => {
        commit("STATUS_LOADING");
        service
          .getAvailableBranches(params)
          .then((resp) => {
            commit("STATUS_SUCCESS");
            commit("SET_BRANCHES_LIST", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            commit("STATUS_ERROR");
            reject(err);
          });
      });
    },
    getBranchById({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit("STATUS_LOADING");
        service
          .getBranchById(id)
          .then((resp) => {
            commit("STATUS_SUCCESS");
            resolve(resp.data);
          })
          .catch((err) => {
            commit("STATUS_ERROR");
            reject(err);
          });
      });
    },

    getBranchReserveSchedule({ commit }, params) {
      return new Promise((resolve, reject) => {
        commit("STATUS_LOADING");
        service
          .getBranchReserveSchedule(params)
          .then((resp) => {
            commit("STATUS_SUCCESS");
            commit("SET_BRANCH_SCHEDULE", resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            commit("STATUS_ERROR");
            commit("SET_BRANCH_SCHEDULE", null);
            reject(err);
          });
      });
    },
    clearBranchSchedule({ commit }) {
      commit("SET_BRANCH_SCHEDULE", null);
    },

    async getBranchSpecialDays({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit("STATUS_LOADING");
        service
          .getBranchSpecialDays(id)
          .then((resp) => {
            commit("STATUS_SUCCESS");
            resolve(resp.data);
          })
          .catch((err) => {
            commit("STATUS_ERROR");
            reject(err);
          });
      });
    },
  },
};
